var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"public-interactions-timeline-container"},_vm._l((_vm.items),function(interaction,index){return _c('div',{key:index},[_c('public-interactions-event-view-timeline-item',{attrs:{"item":interaction,"task-img-promise":_vm.getTaskImage}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }